import jwt from 'jsonwebtoken'
import request from '../../services/request'

import getStorageService from '../../services/storage'

const TOKEN_KEY = 'token'
const HAS_USER_KEY = 'hasUser'
const storageService = getStorageService()

const auth = {
  async login(username, password) {
    const result = await request('/users/login', {
      method: 'POST',
      body: { username, password }
    })

    return result.response.token
  },
  storeToken(token) {
    storageService.setItem(TOKEN_KEY, token)
  },
  retrieveToken() {
    return storageService.getItem(TOKEN_KEY)
  },
  removeToken() {
    storageService.removeItem(TOKEN_KEY)
  },
  storeHasUser() {
    storageService.setItem(HAS_USER_KEY, true)
  },
  removeHasUser() {
    storageService.removeItem(HAS_USER_KEY)
  },
  retrieveHasUser() {
    return storageService.getItem(HAS_USER_KEY)
  },
  decodeToken(token) {
    return jwt.decode(token)
  },
  isTokenExpired(token) {
    const now = Date.now()
    const decoded = auth.decodeToken(token)
    if (!decoded) return true

    return now >= (decoded.exp * 1000)
  }
}

export default auth
